import { render, staticRenderFns } from "./sensitiveWordManage.vue?vue&type=template&id=10d372dc&scoped=true"
import script from "./sensitiveWordManage.vue?vue&type=script&lang=js"
export * from "./sensitiveWordManage.vue?vue&type=script&lang=js"
import style0 from "./sensitiveWordManage.vue?vue&type=style&index=0&id=10d372dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d372dc",
  null
  
)

export default component.exports